import { Box, styled, Typography } from '@mui/material';

export const Operation = styled(Box)(({ theme, side }) => {
  const getColor = () => {
    if (side === '1' || side === 'D') {
      return theme.palette.colors.mainFocusedSoothing;
    }

    if (side === '2' || side === 'E') {
      return theme.palette.colors.highlightSoothing;
    }

    return 'transparent';
  };

  return {
    display: 'flex',
    justifyContent: 'center',
    height: '20px',
    width: 'fit-content',
    minWidth: '70px',
    padding: '0 8px',
    borderRadius: '3px',
    backgroundColor: getColor(),
    border: !side && '1px solid #bee4e7',
    boxSizing: 'border-box',

    [theme.breakpoints.up('md')]: {
      minWidth: '60px',
      height: '16px',
    },
  };
});

export const OperationLabel = styled(Typography)(({ theme, side }) => {
  const getColor = () => {
    if (side === '1' || side === 'D') {
      return theme.palette.colors.mainFocused;
    }

    if (side === '2' || side === 'E') {
      return theme.palette.colors.tradingUp;
    }

    return theme.palette.colors.onSecondaryAndDetailBackground;
  };

  return {
    fontSize: '12px',
    fontWeight: 500,
    textTransform: 'uppercase',
    textAlign: 'center',
    lineHeight: 'normal',
    color: getColor(),
    margin: 'auto',
    [theme.breakpoints.up('md')]: {
      fontSize: '10px',
    },
  };
});
